// Lazy-loaded components
const Lobby = () => import('@/pages/public/CoSoccerLobbyPage.vue')

// Profile
const PlayerProfile = () => import('@/pages/user/ProfilePage.vue')
const ContactInfo = () => import('@/pages/user/ContactInfo.vue')
const EmergencyContactInfo = () => import('@/pages/user/EmergencyContactInfo.vue')
const AcceptWaiver = () => import('@/pages/participant/AcceptWaiver.vue')
const Message = () => import('@/pages/user/MessagePage.vue')

// Dashboard
const Account = () => import('@/pages/dashboard/AccountPage.vue')
const Accounts = () => import('@/pages/dashboard/AccountsPage.vue')
//const ManagerReport = () => import('@/pages/dashboard/ManagerReportPage.vue')
const Dashboard = () => import('@/pages/dashboard/DashboardPage.vue')
const GameReport = () => import('@/pages/dashboard/GameReportPage.vue')
const GameReports = () => import('@/pages/dashboard/GameReportsPage.vue')
const Cards = () => import('@/pages/dashboard/CardsPage.vue')
const League = () => import('@/pages/dashboard/LeaguePage.vue')
const Leagues = () => import('@/pages/dashboard/LeaguesPage.vue')
//const Managers = () => import('@/pages/dashboard/ManagersPage.vue')
const Player = () => import('@/pages/dashboard/PlayerPage.vue')
const Players = () => import('@/pages/dashboard/PlayersPage.vue')
//const Referee = () => import('@/pages/dashboard/RefereePage.vue')
//const Referees = () => import('@/pages/dashboard/RefereesPage.vue')
//const FreeAgents = () => import('@/pages/dashboard/FreeAgentsPage.vue')
const Team = () => import('@/pages/dashboard/TeamPage.vue')
const Teams = () => import('@/pages/dashboard/TeamsPage.vue')
const Invoices = () => import('@/pages/dashboard/InvoicesPage.vue')
const Payments = () => import('@/pages/dashboard/PaymentsPage.vue')
const Games = () => import('@/pages/dashboard/GamesPage.vue')
const TeamSettings = () => import('@/pages/dashboard/TeamSettings.vue')
const AdminPosts = () => import('@/pages/dashboard/AdminPostsPage.vue')
const RefScheduler = () => import('@/pages/dashboard/RefSchedulerPage.vue')
const Users = () => import('@/pages/dashboard/UsersPage.vue')

// Referee Report
const GameMode = () => import('@/pages/participant/GameModePage.vue')
const RefereeReport = () => import('@/pages/participant/RefereeReportPage.vue')

// Free Agent Page
const FreeAgentPlayers = () => import('@/pages/participant/FreeAgentsPage.vue')


// Registration
const Accept = () => import('@/pages/user/AcceptInvitePage.vue')

// Authentication
const Login = () => import('@/pages/public/LoginPage.vue')
const FAQ = () => import('@/pages/public/FAQPage.vue')
const Signup = () => import('@/pages/public/SignupPage.vue')
const Logout = () => import('@/pages/user/LogoutPage.vue')
const ForgotPassword = () => import('@/pages/public/ForgotPassword.vue')
const ResetPassword = () => import('@/pages/user/ResetPassword.vue')

// Terms of Use
const TOU = () => import('@/pages/public/TOUPage.vue')

// Find By Map
const FindByMap = () => import('@/pages/public/FindByMap.vue')

// Public components (not restricted to subdomains)
const NotFoundPage = () => import('@/pages/common/NotFoundPage.vue')


const coSoccerRoutes = [
  {
    path: '/',
    name: 'lobby',
    components: {
      default: Lobby,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout'
    },
    beforeEnter(to, from) {
      // The sessionStorage is cleared on the subdomain when a user clicks 'log out' but the sessionStorage for
      // the root domain is not cleared - so we clear it here. This is not ideal because not all requests from '/'
      // are logout requests. We should improve the way sessionStorage is used so we can delete this.
      if (from.path === '/') {
        //console.log("Lobby.ts: clearCache - CJS - commented out")
        // CJS - sessionStorage should only be set when logging in and cleared when logging out
        //sessionStorage.clear()
      }
    }
  },
  {
    path: '/:pathMatch(.*)',
    name: 'notFound',
    component: NotFoundPage,
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout'
    }
  },
  {
    path: '/profile',
    name: 'profile',
    components: {
      default: PlayerProfile,
    },
    meta: {
      //roles: ['ALL'],
      roles: ['player', 'referee', 'manager', 'admin', 'owner', 'engineer', 'assignor'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  {
    path: '/contact-info',
    name: 'contactInfo',
    components: {
      default: ContactInfo,
    },
    meta: {
      //roles: ['ALL'],
      roles: ['player', 'referee', 'manager', 'admin', 'owner', 'engineer', 'assignor'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  {
    path: '/emergency-contact-info',
    name: 'emergencyContactInfo',
    components: {
      default: EmergencyContactInfo,
    },
    meta: {
      //roles: ['ALL'],
      roles: ['player', 'referee', 'manager', 'admin', 'owner', 'engineer', 'assignor'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  {
    path: '/accept-waiver',
    name: 'acceptWaiver',
    components: {
      default: AcceptWaiver,
    },
    meta: {
      //roles: ['ALL'],
      roles: ['player', 'referee', 'manager', 'admin', 'owner', 'engineer'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  // The path below is identical to the one below that but has post -> messages - this is to enable emails sent with the page=post to continue to work
  // This change was made on 9/4/2025 and can be removed at some point
  {
    path: '/message/:id',
    name: 'post',
    components: {
      default: Message,
    },
    meta: {
      roles: ['player', 'referee', 'manager', 'admin', 'owner', 'engineer'],
      //roles: ['player', 'manager', 'admin', 'owner', 'engineer'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  {
    path: '/message/:id',
    name: 'message',
    components: {
      default: Message,
    },
    meta: {
      //roles: ['player', 'referee', 'manager', 'admin', 'owner', 'engineer'],
      roles: ['player', 'manager', 'admin', 'owner', 'engineer'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  {
    path: '/games',
    name: 'games',
    components: {
      default: Games,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/practices',
    name: 'practices',
    components: {
      default: Games,
    },
    meta: {
      roles: ['manager'],
      layout: 'DashboardLayout'
    },
  },
  {
    //path: '/team-settings/:id',
    path: '/team-settings',
    name: 'teamSettings',
    components: {
      default: TeamSettings,
    },
    meta: {
      roles: ['manager'],
      layout: 'DashboardLayout',
      forceRedirect: true
    },
  },
  {
    path: '/game-mode/:id',
    name: 'gameMode',
    components: {
      default: GameMode,
    },
    meta: {
      roles: ['referee', 'admin', 'owner', 'engineer'],
      //roles: ['referee', 'admin', 'owner', 'engineer', 'assignor'],
      //layout: 'LobbyLayout'
      layout: 'CoSoccerLayout'
    },
  },
  {
    path: '/referee-report',
    name: 'refereeReport',
    components: {
      default: RefereeReport,
    },
    meta: {
      roles: ['referee', 'admin', 'owner', 'engineer'],
      //roles: ['referee', 'admin', 'owner', 'engineer', 'assignor'],
      //layout: 'LobbyLayout'
      layout: 'CoSoccerLayout'
    },
  },
  {
    path: '/free-agents/:name',
    name: 'freeAgentPlayers',
    components: {
      default: FreeAgentPlayers,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout'
    },
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    components: {
      default: Dashboard,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/dashboard',
    name: 'leagueDashboard1',
    components: {
      default: Dashboard,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/dashboard',
    name: 'leagueDashboard2',
    components: {
      default: Dashboard,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/accounts',
    name: 'accounts',
    components: {
      default: Accounts,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/accounts/:id',
    name: 'account',
    components: {
      default: Account,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/leagues',
    name: 'leagues',
    components: {
      default: Leagues,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/leagues/:id',
    name: 'league',
    components: {
      default: League,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/teams',
    name: 'teams',
    components: {
      default: Teams,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/teams/:id',
    name: 'team',
    components: {
      default: Team,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
    {
    path: '/roster',
    name: 'roster',
    components: {
      default: Team,
    },
    meta: {
      roles: ['manager'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/players/:id',
    name: 'player',
    components: {
      default: Player,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer', 'assignor'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/managers',
    name: 'managers',
    components: {
      //default: Managers,
      default: Players,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/players_inactive',
    name: 'players_inactive',
    components: {
      default: Players,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/players',
    name: 'players',
    components: {
      default: Players,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/users',
    name: 'users',
    components: {
      default: Users,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/game-reports',
    name: 'gameReports',
    components: {
      default: GameReports,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer', 'assignor'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/game-reports/:id',
    name: 'gameReport',
    components: {
      default: GameReport,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer', 'assignor'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/cards',
    name: 'cards',
    components: {
      default: Cards,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/suspensions',
    name: 'suspensions',
    components: {
      default: Cards,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/referees',
    name: 'referees',
    components: {
      //default: Referees,
      default: Players,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer', 'assignor'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/freeagents',
    name: 'freeagents',
    components: {
      //default: FreeAgents,
      default: Players,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/invoices',
    name: 'invoices',
    components: {
      default: Invoices,
    },
    meta: {
      roles: ['manager', 'admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/payments',
    name: 'payments',
    components: {
      default: Payments,
    },
    meta: {
      //roles: [ 'admin', 'owner', 'engineer'],
      roles: [ 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/admin-posts',
    name: 'admin-posts',
    components: {
      default: AdminPosts,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/auto-comms',
    name: 'auto-comms',
    components: {
      default: AdminPosts,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/ref-scheduler',
    name: 'ref-scheduler',
    components: {
      default: RefScheduler,
    },
    meta: {
      roles: ['admin', 'owner', 'engineer', 'assignor'],
      layout: 'DashboardLayout'
    },
  },
  {
    path: '/account-invoices',
    name: 'account-invoices',
    components: {
      default: Invoices,
    },
    meta: {
      roles: ['engineer'],
      layout: 'DashboardLayout'
    },
  },

  //{
  //  path: '/referees/:id',
  //  name: 'referee',
  //  components: {
  //    default: Referee,
  //  },
  //  meta: {
  //    roles: ['admin', 'owner', 'engineer'],
  //    layout: 'DashboardLayout'
  //  },
  //},
  // {
  //   path: '/manager-report',
  //   name: 'managerReport',
  //   components: {
  //     default: ManagerReport,
  //   },
  //   meta: {
  //     roles: ['manager', 'admin', 'owner', 'engineer'],
  //     layout: 'DashboardLayout'
  //   },
  // },
  // {
  //   path: '/settings',
  //   name: 'settings',
  //   components: {
  //     default: Dashboard,
  //   },
  //   meta: {
  //     roles: ['player', 'manager', 'admin', 'owner', 'engineer'],
  //     layout: 'DashboardLayout'
  //   },
  // },

  {
    path: '/login',
    name: 'login',
    components: {
      default: Login,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },
  {
    path: '/faq',
    name: 'faq',
    components: {
      default: FAQ,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },
  {
    path: '/logout',
    name: 'logout',
    components: {
      default: Logout,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },  
  {
    path: '/users/password/new',
    name: 'forgotPassword',
    components: {
      default: ForgotPassword,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },
  {
    path: '/users/password/edit',
    name: 'resetPassword',
    components: {
      default: ResetPassword,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },
  {
    path: '/signup',
    name: 'signup',
    components: {
      default: Signup,
    },
    meta: {
      roles: ['engineer'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },
  {
    path: '/users/invitation/accept',
    name: 'acceptInvite',
    components: {
      default: Accept,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    components: {
      default: TOU,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true
    },
  },
  {
    path: '/find-league',
    name: 'find-league',
    components: {
      default: FindByMap,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },
  {
    path: '/find-tournament',
    name: 'find-tournament',
    components: {
      default: FindByMap,
    },
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout',
      forceRedirect: true,
    },
  },
  {
    path: '/:pathMatch(.*)',
    name: 'notFound',
    component: NotFoundPage,
    meta: {
      roles: ['ALL'],
      layout: 'CoSoccerLayout'
    }
  }
]

export default coSoccerRoutes
